import { type MylensesInsightsPageView, type MylensesInsightsSections } from "@snapchat/blizzard-schema";

export interface InsightsPageEventData {
    event: MylensesInsightsPageView["event_name"];
    lensId: string;
    section: MylensesInsightsSections;
}

export const createInsightsPageEvent = (
    { event, lensId, section }: InsightsPageEventData,
    sessionId: string,
): MylensesInsightsPageView => ({
    event_name: event,
    lens_id: lensId,
    section: section,
    mylenses_session_id: sessionId,
});
